// store/modules/settings.js
const state = {
    lang: localStorage.getItem('lang') || 'en', // 初始值从 localStorage 中读取，默认为 'en'
    cartNumber: 0,
};

const mutations = {
    setLang(state, value) {
        state.lang = value;
        localStorage.setItem('lang', value);
    },
    setCartNumber(state, value) {
        state.cartNumber = value;
    },
};

const actions = {
    saveToLocalStorage({ commit }, value) {
        commit('setLang', value);
    },
    ActionsCartNumber({ commit }, value) {
        commit('setCartNumber', value);
    },
};

const getters = {
    getLang: state => state.lang,
    getcartNumber: state => state.cartNumber,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};